import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
const outcomes = [{
  title: 'One system instead of fifty logins',
  body: 'Calls, texts, leads, follow-up, invoices, all in one place you actually check.'
}, {
  title: 'No more calling a different vendor for every problem',
  body: 'One team owns the whole thing. You stop playing middleman between four companies who blame each other.'
}, {
  title: 'One place for a solo operator or a whole crew',
  body: 'Works the same whether it’s you and a truck or five crews out on jobs. It grows when you do.'
}, {
  title: 'No more missed leads',
  body: 'Every call, text, and Yelp message gets answered, including the ones that come in while you’re working.'
}];
export function Outcomes() {
  return <section className="border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-617" data-mp="asuutokdmpg7">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-24" data-id="element-618" data-mp="fs7ek0fybgek">
        <SectionLabel data-id="element-619" data-mp="fqe8ond5x07m">What changes</SectionLabel>
        <h2 className="mt-8 max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-620" data-mp="32wgephrj1u8l">
          Four things stop being your problem.
        </h2>
        <ul className="mt-12 grid grid-cols-1 gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-621" data-mp="2t7gddrpjymr8">
          {outcomes.map((o, i) => <motion.li key={o.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="border-t border-[#1c1c1c] pt-6" data-id="element-622" data-mp="2p6wfglx5nf41" data-mpi={i}>
              <h3 className="text-lg font-semibold leading-snug text-white" data-id="element-623" data-mp="2a940pvzfmuqw">{o.title}</h3>
              <p className="mt-2.5 max-w-md text-sm leading-relaxed text-neutral-400" data-id="element-624" data-mp="268tmxx5ef01h">
                {o.body}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}